export enum ResponseCode {
  SUCCESS = 0,
  UNAUTHORIZED = -1,
  ERROR = -2,
  RECORD_NOT_EXISTS = -3,
  PARAMS_NOT_EXISTS = -4,
  NOT_FOUND = -5,
  INCORRECT = -6,
  ALREADY_EXISTS = -7,
  EXPIRED = -8,
  INVALID = -9,
  DELETED = -11,
  NOT_ENABLED = -12,
  NOT_ENOUGH_SEATS = -13,
  UNEXPECTED_VALUE = -14,
  MISSING_TOKEN = -17,
  BLOCKED_USER_EMAIL = -19,

  INVALID_PROVIDER = -100,
  REFRESH_TOKEN = -101,
  INCORRECT_PASSWORD = -102,
  ORG_NOT_FOUND = -103,
  ORG_SSO_NOT_CONFIGURED = -104,
  ORG_SEAT_EXCEEDED = -105,
  INACTIVE_USER = -106,
  // Onboarding is unfinished, so the server issues no session. The code names the missing
  // step; there is no user object to read. See linq-alpha-server#3858.
  EMAIL_UNVERIFIED = -107,
  APPROVAL_PENDING = -108,
}
